<section class="about-why dingo-section dingo-bg-accent">
  <div class="container">
    <div class="about-split">
      <article class="about-why-panel reveal-on-scroll" data-reveal="card">
        <p class="about-kicker">¿Por qué elegirnos?</p>
        <h2 class="about-section-title">
          Un socio para crecer con <span class="highlight-green">estructura y resultados</span>
        </h2>
        <p class="about-section-desc about-section-desc--left">
          Combinamos experiencia, capacidad de ejecución y visión de negocio para convertir estrategia en crecimiento
          medible.
        </p>
      </article>

      <div class="about-why-grid">
        @for (reason of reasons; track reason.title; let i = $index) {
        <article class="about-why-item reveal-on-scroll" data-reveal="card" [style.--reveal-order]="i">
          <div class="about-why-icon">
            <i class="bi {{ reason.icon }}"></i>
          </div>
          <div>
            @if (reason.kicker) {
            <p>{{ reason.kicker }}</p>
            }
            <h3>{{ reason.title }}</h3>
          </div>
        </article>
        }
      </div>
    </div>
  </div>
</section>
